import React, {PureComponent, ComponentType} from 'react';

// This hoc applies other hocs only when a condition is true. It also forwards refs.
// Read about forwardedRefs here:
// https://reactjs.org/docs/forwarding-refs.html#forwarding-refs-in-higher-order-components
// Example in Video.js in export default.

const ConditionalHoc = <P extends {}>(hoc, Component: ComponentType<P>, func: CallableFunction) => {
    type WrapperComponentPropsWithForwardedRef = P & {
        forwardedRef: React.Ref<ComponentType<P>>;
    };

    class ConditionalHocClass extends PureComponent<WrapperComponentPropsWithForwardedRef, {}> {
        static propTypes = {
            ...hoc.propTypes,
            ...Component.propTypes
        };

        render() {
            const {forwardedRef} = this.props;

            if (func(this.props)) {
                const WrappedComponent = hoc(Component);
                return <WrappedComponent ref={forwardedRef} {...this.props} />;
            }

            return <Component ref={forwardedRef} {...this.props} />;
        }
    }

    return React.forwardRef<ComponentType<P>, P>((props, ref) => {
        //@ts-ignore
        return <ConditionalHocClass {...props} forwardedRef={ref} />;
    });
};

export default ConditionalHoc;
